import { type ReactNode } from 'react';

import { Box } from '@mui/material';
import { proAccountThemeCoreUI } from '../themes';

import type { IStylesOverrides } from '../common-types';

interface WidgetWrapperProps {
  styleOverrides?: IStylesOverrides;
  testId?: string;
  children: ReactNode;
}

export const WidgetWrapper = ({
  styleOverrides,
  testId,
  children,
}: WidgetWrapperProps) => {
  const defaultWidgetBackground = proAccountThemeCoreUI.palette.common.white;

  return (
    <Box
      data-testid={testId}
      sx={{
        backgroundColor:
          styleOverrides?.backgroundColour ?? defaultWidgetBackground,
      }}
    >
      {children}
    </Box>
  );
};
